import React from 'react'
import * as styles from './productCard.module.css'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Svg1 from '../../images/svg/check.svg'

const ProductCard = ({ product }) => {
  const image = getImage(product.productImage)
  return (
    <div className={styles.product}>
      <GatsbyImage image={image} alt="website img" />
      <span>{product.productTitle}</span>
      <span>{product.productDescription}</span>
      <ul>
        {product.productFeatures.map((el) => {
          return (
            <li key={el}>
              <Svg1 />
              <p>{el}</p>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default ProductCard
